import { render, staticRenderFns } from "./search-hero.vue?vue&type=template&id=69345724&"
import script from "./search-hero.vue?vue&type=script&lang=js&"
export * from "./search-hero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports